<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  name: 'UserNotifications',
  computed: {
    ...mapState('users',{
      notificationSettings : s => s.notificationSettings
    }),
    authorizedNotificationItems(){
      let vm = this
      return vm.notificationSettings.items.filter(x => {
        return vm.$p(x.permissions[0],x.permissions[1] || undefined)
      })
    }
  },
  methods: {
    ...mapMutations('users', [
      
    ])
  }
}
</script>

<template>
  <div class="layout-padding">
    <h5 style="padding-bottom:30px"><q-icon name="fa fa-bell-o" color="primary" /> Notification Settings</h5>
      <div class="sl-row text-bold">
        <div class="sl-col-8">
          Description
        </div>
        <div class="sl-col-2 text-center">E-mail</div>
        <div class="sl-col-2 text-center">In App</div>
      </div>
      <div class="sl-row" v-for="(notification,i) in authorizedNotificationItems" :key="i">
        <div class="sl-col-8">
          {{notification.description}}
        </div>
        <div class="sl-col-2 text-center">
          <q-checkbox v-model="notification.email" />
        </div>
        <div class="sl-col text-center">
          <q-checkbox v-model="notification.inapp" />
        </div>         
      </div>
  </div>
</template>

<style>
</style>
